import FqApi from '@/services/fq-api'

/**
 * Front-end feature flags. The endpoint is anonymous because the login page runs before the
 * SPA has a token, and the result is memoised because the router guard consults it on every
 * navigation.
 *
 * The catch fails closed: an unreachable API must leave the app on the legacy login, never on
 * a half-enabled new one the user cannot complete.
 */

const FLAGS_OFF = Object.freeze({
  jwtLoginEnabled: false
})

let cached = null

export function getWebFeatures() {
  if (!cached) {
    cached = FqApi.get('/settings/webfeatures')
      .then(response => ({ ...FLAGS_OFF, ...(response && response.data) }))
      .catch(() => FLAGS_OFF)
  }
  return cached
}

export function isJwtLoginEnabled() {
  return getWebFeatures().then(flags => flags.jwtLoginEnabled === true)
}

/** Test seam — drops the memoised result so each spec starts clean. */
export function resetWebFeaturesCache() {
  cached = null
}

export default { getWebFeatures, isJwtLoginEnabled, resetWebFeaturesCache }
